import { Request } from '../request';
import {
    IAdBudget,
    IAdMetricsQuery,
    IPracticeMetricsQuery,
    IPracticeByProviderQuery,
    IPracticeSaveRequest,
} from 'types/marketing';
import { IBookingLimitSaveReq } from 'types/bookingLimit';

export const getAdStatus = () => Request.get({ url: '/schedule-server/provider/ad/status' });

export const getAdBudget = () => Request.get({ url: '/schedule-server/provider/ad/budgets/current' });

export const updateAdBudget = (data: IAdBudget) =>
    Request.post({ url: '/schedule-server/provider/ad/budgets/saveOrUpdate', params: data });

export const getAdBudgetByOps = (providerId: number) =>
    Request.get({ url: `/admin-server/provider/ad/budgets/${providerId}` });

export const updateAdBudgetByOps = (providerId: number, data: IAdBudget) =>
    Request.post({ url: `/admin-server/provider/ad/budgets/saveOrUpdate`, params: { ...data, providerId } });

export const getAdMetrics = (data: IAdMetricsQuery) =>
    Request.post({ url: '/schedule-server/provider/ad/metrics/summary', params: data });

export const pauseBudget = (data: { reason: string }) =>
    Request.post({ url: '/schedule-server/provider/ad/budgets/pause', params: data });

export const getAdStatusByOps = (providerId: number) =>
    Request.get({ url: `/admin-server/provider/ad/status/${providerId}` });

export const getMarketReport = () => Request.get({ url: '/schedule-server/provider/ad/metrics/report' });

// Practice (Group) APIs

export const getPracticeOverview = () => Request.get({ url: '/schedule-server/provider/practice/ad/overview' });

export const getPracticeMetricsSummary = (data: IPracticeMetricsQuery) =>
    Request.post({ url: '/schedule-server/provider/practice/ad/metrics/summary', params: data });

export const getPracticeMetricsTrend = (data: IPracticeMetricsQuery) =>
    Request.post({ url: '/schedule-server/provider/practice/ad/metrics/trend', params: data });

export const getPracticeByProvider = (data: IPracticeByProviderQuery) =>
    Request.post({ url: '/schedule-server/provider/practice/ad/byProvider/list', params: data });

export const getPracticePoolBudget = () => Request.get({ url: '/schedule-server/provider/practice/ad/budgets' });

export const savePracticePoolBudget = (data: IPracticeSaveRequest) =>
    Request.post({ url: '/schedule-server/provider/practice/ad/budgets/saveOrUpdate', params: data });

/* ── Patient limits（新患者周上限）──────────────────────────────────
 * 上限是 practice 级的一份数据：Practice View 与 My Marketing 范围不同、改的是同一个值。
 * 任一处保存成功后，另一处的数据即失效，需要重新拉取。
 * 契约见飞书《Patient Booking Limit — 前端对接文档》。
 */

/** 当前 provider 自己的上限与用量。团队成员拿到 canEdit=false，只读。 */
export const getBookingLimit = () =>
    Request.get({ url: '/schedule-server/provider/booking-limit' });

/** Practice 级总览：规则 + 汇总 + 每个成员的用量与状态。非 owner/admin 返回 4003。 */
export const getPracticeBookingLimit = () =>
    Request.get({ url: '/schedule-server/provider/practice/booking-limit' });

/**
 * 保存前预览「这次改动会影响谁」，只读不落库。
 * **每次保存前都要调，关闭开关也要调** —— 调低会立刻把超标成员从搜索里摘掉，
 * 确认框需要 willPause 才能点名。
 */
export const previewBookingLimit = (data: IBookingLimitSaveReq) =>
    Request.post({ url: '/schedule-server/provider/booking-limit/save-preview', params: data });

/** 保存。响应 data 为 null，保存后必须重新拉取状态。 */
export const saveBookingLimit = (data: IBookingLimitSaveReq) =>
    Request.post({ url: '/schedule-server/provider/booking-limit/save', params: data });

/** 修改历史，倒序最多 100 条。practice 内任意活跃成员可读。 */
export const getBookingLimitHistory = () =>
    Request.get({ url: '/schedule-server/provider/booking-limit/history' });
